import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=a72ed576"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"
import style0 from "./Reports.vue?vue&type=style&index=0&id=a72ed576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports